import GenerateReport from '../Reports/Web/BlueFormatSupport-Page/GenerateReport'
import CertInReport from '../Reports/Web/CertInSupport-Page/CertInReport'
import IsecNavbar from './IsecNavbar'
import IsecNavbar2 from './IsecNavbar2'
import NetworkCertinReport from '../Reports/Network/NetworkInternalCertinReport/NetworkCertinReport'
import { useAuth } from '../../Context/UserContext';
import ClientNavbar1 from '../../Client-components/Pages/ClientNavbar1'


function Report() {
    const { isSidebarCollapsed } = useAuth();
    return (
        <div className='table-list-dash'>
            <div>
                <div className='client_navabr1'>
                    <ClientNavbar1 />
                </div>
                <div className='isecurion_navbar_second'><IsecNavbar2 /></div>
            </div>

            <div className='wrap_isecurion_navbar_dashboard'>
                <div className={isSidebarCollapsed ? 'isecuriondash-navbar' : 'isecuriondash_close_navbar'}>
                    <IsecNavbar />
                </div>
                <div className={isSidebarCollapsed ? 'wrap_isecurion_dashboard_data_open' : 'wrap_isecurion_dashboard_data'}>
                    <div className='wrap_report_component'>
                        <div className='wrap_blue_format'>
                            <GenerateReport />
                        </div>

                        <div className='wrap_certin_format'>
                            <CertInReport />
                        </div>

                        <div className='wrap_certin_format'>
                            < NetworkCertinReport />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Report
